export const FAILURE_DIALOG_TABLE_HEIGHT = '135px';
